import { render, staticRenderFns } from "./TopicOptions.vue?vue&type=template&id=c6820702&"
import script from "./TopicOptions.vue?vue&type=script&lang=js&"
export * from "./TopicOptions.vue?vue&type=script&lang=js&"
import style0 from "./TopicOptions.vue?vue&type=style&index=0&id=c6820702&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports